// Implements: F-UIX-017
/**
 * The versions before and after one: where "previous version" and "next version" lead.
 *
 * The order is the order the versions were made (`sequence_number`), across branches, as
 * the tree lists them: the tree is what the person may see, so a step never leads to a
 * version the server did not list. A version the list does not hold has no neighbours.
 */

import type { VersionTreeNode } from "../../../types/api";

export interface VersionNeighbours {
  readonly previous: VersionTreeNode | null;
  readonly next: VersionTreeNode | null;
}

export function versionNeighbours(
  nodes: readonly VersionTreeNode[],
  versionId: string,
): VersionNeighbours {
  const ordered = [...nodes].sort((left, right) => left.sequence_number - right.sequence_number);
  const at = ordered.findIndex((node) => node.id === versionId);
  if (at === -1) return { previous: null, next: null };
  return { previous: ordered[at - 1] ?? null, next: ordered[at + 1] ?? null };
}
